import { Box, Button, ButtonGroup } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import { addBeginner, isBeginner, removeBeginner } from '../../../state';
import GW2Button from '../../gw2components/GW2Button';

export default function BuildOptions({ hasBeginner, buttons, profession }) {
  const dispatch = useDispatch();
  const title = typeof window === 'undefined' ? '' : window?.location.pathname;
  const beginner = useSelector(isBeginner(title));

  if (!hasBeginner && (!buttons || buttons.length === 0)) return null;

  return (
    <Box
      sx={{
        marginTop: 2,
        marginBottom: 2,
        //  border: ' 1px solid #e57373',
        //  padding: '16px 16px',
        //  borderRadius: '4px',
        //  marginBottom: '16px',
      }}
    >
      <Box display="flex" justifyContent="space-between">
        {hasBeginner && (
          <ButtonGroup disableElevation color="error">
            <Button
              variant={beginner ? 'contained' : 'outlined'}
              onClick={(e) => dispatch(addBeginner(title))}
            >
              Beginner
            </Button>
            <Button
              variant={!beginner ? 'contained' : 'outlined'}
              onClick={(e) => dispatch(removeBeginner(title))}
            >
              Advanced
            </Button>
          </ButtonGroup>
        )}

        {buttons && (
          <Box
            display="flex"
            flexDirection="row"
            flexWrap="wrap"
            alignSelf="center"
          >
            {buttons.map((btn) => (
              <div key={btn.link}>
                <GW2Button to={btn.link} profession={profession}>
                  <Box alignItems="end">{btn.content()}</Box>
                </GW2Button>
              </div>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
}
